import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FeatureDynamicService } from '../../modules/feature-dynamic';
import { BreakpointService } from '../../services/breakpoint.service';
import { CurrentRouteService } from '../../services/current-route.service';
import { ApplicationInfoPanelComponent } from '../application-info-panel/application-info-panel.component';
import { MenuBarComponent } from '../menu-bar/menu-bar.component';

@Component({
    selector: 'app-main',
    imports: [
        RouterOutlet,
        MenuBarComponent,
        //ApplicationFabContentComponent,
        ApplicationInfoPanelComponent,
        //DonationComponent
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
    readonly breakpointService = inject(BreakpointService);
    readonly currentRouteService = inject(CurrentRouteService);
    readonly featureDynamicService = inject(FeatureDynamicService);

    showCarouselOutlet = computed((): boolean => {
        const currentRoute = this.currentRouteService.currentRoute();

        return (!currentRoute.startsWith('/auth')
            && !currentRoute.startsWith('/member')
            && !currentRoute.startsWith('/wetter-aushang')
            && !currentRoute.startsWith('/kontakt/')
            && !currentRoute.startsWith('/member-support')
            && !currentRoute.startsWith('/ref')
            && !currentRoute.startsWith('/regatta/twilight-races')
            && !currentRoute.startsWith('/regatta/race-track')
            && !currentRoute.startsWith('/regatta/hall-of-fame')
            && !currentRoute.startsWith('/club/ausbildung')
            && !currentRoute.startsWith('/videos')
            && !currentRoute.startsWith('/boote/eissegeln'));
    });

    showMenuBar = computed((): boolean => {
        const currentRoute = this.currentRouteService.currentRoute();
        const breakpoint = this.breakpointService.breakpoint();

        return (breakpoint !== 'MOBILE' && !currentRoute.startsWith('/wetter-aushang'));
    });

    showApplicationInfoPanel = computed((): boolean => {
        const currentRoute = this.currentRouteService.currentRoute();

        return (!currentRoute.startsWith('/member')
            && !currentRoute.startsWith('/wetter-aushang'));
    });
}
